<div class="portal-shell">
  <div class="portal-header">
    <ng-container *ngIf="isMultiClientMode; else staticClientName">
      <select class="portal-client-select" [value]="clientId" (change)="selectClient(+$any($event.target).value)">
        <option *ngFor="let c of availableClients" [value]="c.id">{{ c.name }}</option>
      </select>
    </ng-container>
    <ng-template #staticClientName>
      <span class="portal-client-name">{{ clientName }}</span>
    </ng-template>
    <div class="user-profile-container">
      <button mat-icon-button class="user-profile-button" [matMenuTriggerFor]="clientMenu">
        <span class="user-avatar"><mat-icon>person</mat-icon></span>
      </button>
      <mat-menu #clientMenu="matMenu">
        <div class="user-menu-header">
          <span class="user-menu-name">{{ contactName }}</span>
        </div>
        <mat-divider></mat-divider>
        <button mat-menu-item (click)="logout()">
          <mat-icon>logout</mat-icon>
          <span>Sign Out</span>
        </button>
      </mat-menu>
    </div>
  </div>

  <div class="portal-content">
    <h3 class="portal-section-title">Notification History</h3>

    <div class="filter-container">

      <!-- Filters Group -->
      <div class="filter-group">
        <span class="group-label">Filters</span>
        <div class="serviceTypeFilter">
          <mat-form-field appearance="outline">
            <mat-label>Filter by Service Type</mat-label>
            <mat-select multiple [(value)]="selectedServiceTypes">
              <mat-option *ngFor="let t of serviceTypes" [value]="t">{{ t }}</mat-option>
            </mat-select>
          </mat-form-field>
        </div>
        <div class="filterSearchButton">
          <button mat-raised-button (click)="applyFilters()">Apply Filter</button>
        </div>
      </div>

      <!-- Search Group -->
      <div class="search-group">
        <span class="group-label">Search</span>
        <div class="deceasedNameSearch">
          <mat-form-field appearance="outline">
            <mat-label>Deceased Name Search</mat-label>
            <input matInput [(ngModel)]="nameSearchValue"
                   [disabled]="probateSearchValue.trim().length > 0"
                   (keyup.enter)="applySearch()" />
            <button *ngIf="isNameSearchActive" matSuffix mat-icon-button (click)="clearNameSearch()">
              <mat-icon>close</mat-icon>
            </button>
          </mat-form-field>
        </div>
        <div class="probateSearch">
          <mat-form-field appearance="outline">
            <mat-label>Probate Search</mat-label>
            <input matInput [(ngModel)]="probateSearchValue"
                   [disabled]="nameSearchValue.trim().length > 0"
                   (keyup.enter)="applySearch()" />
            <button *ngIf="isProbateSearchActive" matSuffix mat-icon-button (click)="clearProbateSearch()">
              <mat-icon>close</mat-icon>
            </button>
          </mat-form-field>
        </div>
        <div class="dateFilter">
          <mat-form-field appearance="outline" class="date-field">
            <mat-label>From</mat-label>
            <input matInput [matDatepicker]="startPicker" [(ngModel)]="startDate" readonly (click)="startPicker.open()" />
            <mat-datepicker-toggle matIconSuffix [for]="startPicker"></mat-datepicker-toggle>
            <mat-datepicker #startPicker></mat-datepicker>
          </mat-form-field>
          <mat-form-field appearance="outline" class="date-field">
            <mat-label>To</mat-label>
            <input matInput [matDatepicker]="endPicker" [(ngModel)]="endDate" readonly (click)="endPicker.open()" />
            <mat-datepicker-toggle matIconSuffix [for]="endPicker"></mat-datepicker-toggle>
            <mat-datepicker #endPicker></mat-datepicker>
          </mat-form-field>
          <button *ngIf="startDate || endDate" mat-icon-button class="clear-date-button"
                  (click)="clearDateSearch()">
            <mat-icon>close</mat-icon>
          </button>
        </div>
        <div class="searchButton">
          <button mat-raised-button (click)="applySearch()"
                  [disabled]="!nameSearchValue.trim() && !probateSearchValue.trim() && !startDate && !endDate">
            Search
          </button>
        </div>
      </div>

      <div class="paginator">
        <mat-paginator
          [length]="filteredNotifications.length"
          [pageSize]="pageSize"
          [pageSizeOptions]="pageSizeOptions"
          [pageIndex]="pageIndex"
          (page)="pageChanged($event)"
          showFirstLastButtons>
        </mat-paginator>
      </div>

    </div>

    @if(filteredNotifications.length === 0) {
      <div class="portal-empty">No notifications found.</div>
    } @else {
      <div class="portal-table-wrapper">
        <table class="portal-table">
          <thead>
            <tr>
              <th class="col-check">
                <input type="checkbox" [checked]="allSelected" (change)="toggleSelectAll()" title="Select All" />
              </th>
              <th>Probate ID</th>
              <th>Deceased Name</th>
              <th>Service Type</th>
              <th>Date Notified</th>
              <th>Invoice No</th>
              <th class="col-docs">Preview</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let n of pagedNotifications"
                [class.selected-row]="isSelected(n.probateId)"
                [class.payment-cancelled-row]="n.paymentCancelledDate"
                [matTooltip]="n.paymentCancelledDate ? 'Payment cancelled — this notification has been credited and document access has been removed. A credit note will appear on a future invoice.' : ''"
                matTooltipPosition="above">
              <td class="col-check">
                <input type="checkbox" [checked]="isSelected(n.probateId)" (change)="toggleRow(n.probateId)" />
              </td>
              <td>{{ n.probateId }}</td>
              <td>{{ n.deceasedName || '—' }}</td>
              <td>{{ n.serviceTypeName || '—' }}</td>
              <td>{{ formatDate(n.clientEmailedDate) }}</td>
              <td>{{ n.invoiceId || '—' }}</td>
              <td class="col-docs">
                <div class="doc-icons">
                  <button type="button"
                          class="doc-icon-btn theme-gop"
                          [class.disabled]="!n.hasGop || !!n.paymentCancelledDate"
                          [disabled]="!n.hasGop || !!n.paymentCancelledDate"
                          [matTooltip]="n.paymentCancelledDate ? 'Not accessible — payment cancelled' : n.hasGop ? 'Preview Grant of Probate' : 'Grant of Probate not available'"
                          (click)="openPreview(n, 'grant')">
                    <span class="icon-circle"><mat-icon>gavel</mat-icon></span>
                    <span class="icon-label">GoP</span>
                  </button>
                  <button type="button"
                          class="doc-icon-btn theme-will"
                          [class.disabled]="!n.hasWill || !!n.paymentCancelledDate"
                          [disabled]="!n.hasWill || !!n.paymentCancelledDate"
                          [matTooltip]="n.paymentCancelledDate ? 'Not accessible — payment cancelled' : n.hasWill ? 'Preview Will' : 'Will not available'"
                          (click)="openPreview(n, 'will')">
                    <span class="icon-circle"><mat-icon>auto_stories</mat-icon></span>
                    <span class="icon-label">Will</span>
                  </button>
                  <button type="button"
                          class="doc-icon-btn theme-notif"
                          [class.disabled]="!n.hasNotification || !!n.paymentCancelledDate"
                          [disabled]="!n.hasNotification || !!n.paymentCancelledDate"
                          [matTooltip]="n.paymentCancelledDate ? 'Not accessible — payment cancelled' : n.hasNotification ? 'Preview Notification' : 'Notification pdf does not exist yet'"
                          (click)="openPreview(n, 'notification')">
                    <span class="icon-circle"><mat-icon>mail</mat-icon></span>
                    <span class="icon-label">Notif</span>
                  </button>
                </div>
              </td>
            </tr>
          </tbody>
        </table>
      </div>

      @if(someSelected) {
        <div class="download-bar">
          <span class="download-label">{{ selectedProbateIds.size }} selected — Download:</span>
          <select [(ngModel)]="selectedDocType" class="doc-type-select" [disabled]="allowCombined">
            <option value="notification">Notification</option>
            <option value="will">Will</option>
            <option value="grant">Grant of Probate</option>
          </select>
          <button mat-raised-button (click)="downloadZip()" [disabled]="allowCombined">Download as ZIP</button>
          <label class="combined-toggle">
            <input type="checkbox" [(ngModel)]="allowCombined" />
            <span>Allow Combined Files</span>
          </label>
          @if(allowCombined) {
            <select [(ngModel)]="selectedCombineMode" class="doc-type-select">
              <option value="all">Combine All Probates</option>
              <option value="separate">Combine Separately</option>
            </select>
            <button mat-raised-button (click)="downloadCombined()">Download Combined Files</button>
          }
          <span [matTooltip]="firstClassCsvTooltip" class="firstclass-csv-tooltip-wrap">
            <button mat-raised-button
                    class="firstclass-csv-btn"
                    [disabled]="!firstClassCsvEligible"
                    (click)="downloadFirstClassCsv()">
              Download FirstClass CSV as Zip
            </button>
          </span>
        </div>
      }

      <div class="portal-results-count">
        Showing {{ filteredNotifications.length }} of {{ notifications.length }} notifications
      </div>
    }
  </div>
</div>
